import { getToken } from "./auth.service";

export const getPublishedEducation = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/education/published`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        method: "GET",
      }
    );
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
};

export const getAllEducation = () => {
  return fetch(`${process.env.REACT_APP_API_URL}/education`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "GET",
  }).then((x) => x.json());
};

export const createEducation = (data: any) => {
  return fetch(`${process.env.REACT_APP_API_URL}/education`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "POST",
    body: JSON.stringify(data),
  }).then((x) => x.json());
};

export const updateEducation = (id: number, data: any) => {
  return fetch(`${process.env.REACT_APP_API_URL}/education/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "PUT",
    body: JSON.stringify(data),
  }).then((x) => x.json());
};

export const deleteEducation = (id: number) => {
  return fetch(`${process.env.REACT_APP_API_URL}/education/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "DELETE",
  }).then((x) => x.json());
};
